import React from "react";
import cn from "classnames";
import { map, join } from 'lodash';
import SvgIcon from '../../../../common/components/svg-icon';
import Checkbox from "./checkbox";

const WithData = ({ summary, handleEditClick, handleUpdateSummary, handleOnChange, className, region }) => {
  const boolToText = (value) => {
    return value ? "yes" : "no";
  };

  const settings = `Settings: Positive: ${boolToText(region.positive)}; Negative: ${boolToText(region.negative)}; Mode: ${region.clip_mode}`;
  const filters = `Filters: ${!region.filters?.length ? 'None' : region.filters}`;
  return (
    <div className="middle -no-margin">
      <div className="region-summary-title">{ `BuzzIQ Summary - ${region.name}` }</div>
      <div className="summary-settings">
        { join([ settings, filters ], "; ") }
      </div>
      <div className={ cn("summary-topics", className) }>
        <ul>
          {
            map(summary.raw_data, (item, key) => (
              <li key={ item.name } >
                <b>{item.name}:</b>
                {' '}
                { item.long_summary }
              </li>
            ))
          }
        </ul>
      </div>
      <div className="buttons">
        <a className="link -green" onClick={ handleEditClick }>
          <SvgIcon name="pen-nocolor" />
          Edit Summary
        </a>
        <a className="link" onClick={ () => handleUpdateSummary(summary.id, region.id) }>
          <SvgIcon name="refresh-nocolor" />
          Update Summary
        </a>
        <Checkbox
          title="Add to Report"
          className="link"
          value={ summary?.add_to_report || false }
          onChange={ handleOnChange }
        />
      </div>
    </div>
  );
};

export default WithData;
